import styled, { css } from 'styled-components/macro';
import { Table, PopUpView, Icon } from '~/components';
import Tabs from './components/Tabs';

export const Container = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 50% 50%;
  flex-grow: 1;
`;

export const ContainerSm = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const TabsSections = styled(Tabs)`
  position: sticky;
  top: 0;
  ${({ tabletMode, theme }) =>
    tabletMode ? `border-top: solid 1px ${theme.gray3}` : null}
`;

export const ShieldBackground = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url(${({ bgImage }) => bgImage});
  background-repeat: no-repeat;
  background-position: ${({ isLocal }) =>
    isLocal
      ? '-176px calc(50% + 160px)'
      : 'calc(100% + 176px) calc(50% + 160px)'};
  background-attachment: fixed;
  filter: grayscale(100%);
  background-size: 700px;
  z-index: 0;
  opacity: 0.1;
`;

export const TableContainerLocal = styled.div`
  height: 100%;
  position: relative;
  background-color: ${({ theme }) => theme.white};

  > div:last-child {
    z-index: 2;
    & > div,
    > table {
      padding-left: 30px;
      padding-bottom: 20px;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    flex-direction: column;
    > div:nth-child(1) {
      padding-left: 0px;
      background-color: ${({ theme }) => theme.lightWithOpacity};
    }
  }
`;

export const TableContainerVisitor = styled.div`
  height: 100%;
  position: relative;
  background-color: ${({ theme }) => theme.dark4};
  > div:last-child {
    z-index: 2;
    & > div,
    > table {
      padding-right: 30px;
      padding-bottom: 20px;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    flex-direction: column;
    > div:nth-child(1) {
      padding-right: 0px;
      background-color: ${({ theme }) => theme.dark4MidOpacity};
    }
  }
`;

export const HeaderTable = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: ${({ isVisitor }) => (isVisitor ? 'row-reverse' : 'row')};
  padding: 25px;
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    justify-content: center;
  }
`;

export const HeaderTableContainer = styled.div`
  background-color: ${({ bgColor }) => bgColor || 'transparent'};
  padding-bottom: 10px;
`;
export const CoachSection = styled.div`
  display: flex;
  justify-content: space-evenly;
  height: 92px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    height: 70px;
  }
`;

export const HeaderTitle = styled.span`
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: 13px;
  text-transform: uppercase;
  color: ${({ isLocal, theme }) => (isLocal ? theme.dark : theme.light)};
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    color: ${props => (props.textColor ? props.textColor : 'inherit')};
    border-bottom: solid 2px
      ${({ textColor, theme }) => textColor || theme.black};
  }
`;

export const Grow = styled.div`
  flex-grow: 1;
`;

export const HeaderInfo = styled.span`
  display: flex;
  font-size: 13px;
  align-items: flex-start;
  color: ${({ isLocal, theme }) => (isLocal ? theme.dark : theme.light)};
  span {
    margin-right: 3px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    justify-content: center;
    padding: 5px;
    background-color: ${({ isLocal, theme }) =>
      isLocal ? theme.lightWithOpacity : theme.dark5};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.xs}px) {
    justify-content: flex-start;
    align-items: center;
    padding: 8px 2px;
    span {
      margin-top: 2px;
      margin-right: 2px;
    }
  }
`;

export const Bold = styled.span`
  font-family: ${({ theme }) => theme.primaryFontBold};
`;

export const HeaderInfoIcon = styled(Icon)`
  @media (max-width: ${({ theme }) => theme.breakpoints.xs}px) {
    margin-right: 2px;
  }
`;

export const HeaderInfoText = styled.span`
  @media (max-width: ${({ theme }) => theme.breakpoints.xs}px) {
    font-size: 9px;
  }
`;

const TableBasic = css`
  position: relative;
  font-family: ${({ theme }) => theme.primaryFontLight};
  z-index: 1;
  table {
    min-height: 100%;
    thead {
      tr {
        cursor: pointer;
        th {
          font-weight: normal;
          color: ${({ theme }) => theme.coral};
          padding: 8px;
          text-transform: uppercase;
          position: sticky;
          top: 42px;
          z-index: 1;
          font-size: 12px;
          @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
            top: 35px;
          }
          @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
            position: relative;
            top: 0px;
          }
          div {
            justify-content: center;
          }
          @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
            padding-top: 100px;
            &:first-child div {
              opacity: 0;
            }
          }
        }
      }
    }
    tbody {
      tr {
        cursor: pointer;
        transition: all 0.3s;
        &.table--selected {
          color: ${({ theme }) => theme.white};
          & td {
            background-color: ${({ theme, competition }) =>
              competition === 1 ? theme.coral : theme.turquoise};
          }
        }
        td {
          border: solid 1px transparent;
          border-right: none;
          border-left: none;
          padding: 8px;
          transition: all 0.3s;
          font-size: 14px;
          height: 72px;
          &:first-child {
            border-left: solid 1px transparent;
          }
          &:last-child {
            border-right: solid 1px transparent;
            //padding-right: 20px;
          }
          &:nth-child(2n) {
          }
        }
      }
    }
  }
`;

export const TableGlobalStats = styled(Table)`
  ${TableBasic}
  table {
    thead {
      tr {
        th {
          color: ${({ theme }) => theme.dark};
          background-color: ${({ theme }) => theme.white};
          ${({ headerSticky }) => (headerSticky ? 'position: sticky;' : '')};
          &:first-child {
            padding: 0;
            line-height: 0;
          }
          &:nth-child(2n) > div {
            font-family: ${({ theme }) => theme.primaryFontBold};
          }

          &:first-child {
            div {
              justify-content: left;
              padding-left: 0px;
              @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
                padding-left: 5px;
              }
            }
          }
        }
      }
    }
    tbody {
      tr {
        td {
          text-align: center;
          &:first-child {
            padding: 0;
            line-height: 0;
            width: 53px;
          }
          &:nth-child(2n) {
            font-family: ${({ theme }) => theme.primaryFontBold};
          }
        }
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    background-color: ${({ theme }) => theme.white};
  }
`;

export const TableGlobalStatsVisitor = styled(Table)`
  ${TableBasic}
  table {
    thead {
      tr {
        th {
          color: ${({ theme }) => theme.white};
          background-color: ${({ theme }) => theme.dark4};
          &:nth-child(2n - 1) {
            font-family: ${({ theme }) => theme.primaryFontBold};
          }
          &:last-child {
            div {
              justify-content: flex-end;
              padding-right: 0px;
              @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
                padding-right: 5px;
              }
            }
          }
        }
      }
    }
    tbody {
      tr {
        td {
          text-align: center;
          &:last-child {
            padding: 0;
            line-height: 0;
            width: 53px;
          }
          &:nth-child(2n - 1) {
            font-family: ${({ theme }) => theme.primaryFontBold};
          }
          @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
            &:first-child {
              padding: 0;
              line-height: 0;
              width: 53px;
            }
          }
        }
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    background-color: ${({ theme }) => theme.darkWithOpacity};
  }
`;

export const ModalPlayer = styled(PopUpView)`
  width: 100vw;
  max-width: 965px;
`;

export const ImageTable = styled.img`
  height: 53px;
  background-color: ${({ theme }) => theme.dark};
`;

export const TrContainer = styled.tr`
  &:hover {
    td {
      background-color: ${({ theme, competition }) =>
        competition === 1 ? theme.coral : theme.turquoise} !important;
      color: ${({ theme }) => theme.white} !important;
    }
  }
  ${({ isTop5, theme }) =>
    isTop5
      ? `
    & > td {
      position: relative;
      &:before{
        content: '';
        top: -2px;
        bottom: -1px;
        right: -1px;
        left: -2px;
        border-top: solid 1px ${theme.yellow} !important;
        border-bottom: solid 1px ${theme.yellow} !important;
        position: absolute;
      }
      &:first-child:before {
        border-left: solid 1px ${theme.yellow} !important;
      }
      &:last-child:before {
        border-right: solid 1px ${theme.yellow} !important;
      }
  }
  `
      : null}
`;
